// extracted by mini-css-extract-plugin
export default {"formHeading":"gS-z","form":"hS-z","submitBtn":"iS-z","disabled":"jS-z","input":"kS-z","error":"lS-z","submitMsg":"mS-z","signIn":"nS-z"};